module.exports = __webpack_public_path__ + "static/AM_Logotype-c343a4beff8442ece480c9a090cbdbbd.svg";